<template>
  <transition name="nav-browse-categories-overlay">
    <div class="nav-browse-categories-overlay" v-if="showNavBrowseOverlay">
      <div class="nav-browse-categories-overlay__content" @click="closeOverlay">
        <div class="nav-browse-categories-overlay__title">Market Categories</div>
        <div class="nav-browse-categories-overlay__items">
          <router-link
            class="nav-browse-categories-overlay__item"
            :to="{ name: 'market-list', params: { headerId: 'all' } }"
          >
            All
          </router-link>
          <template v-for="item in userBrowseHeaders" :key="`overlay-${item.headerId}`">
            <template v-if="item.external">
              <router-link
                v-if="item.name"
                class="nav-browse-categories-overlay__item"
                :to="{ name: item.name }"
              >
                {{ item.title }}
              </router-link>
              <a
                v-else-if="item.href"
                class="nav-browse-categories-overlay__item"
                :href="item.href"
                v-outer-link
              >
                {{ item.title }}
              </a>
            </template>
            <router-link
              v-else
              class="nav-browse-categories-overlay__item"
              :to="{
                name: 'market-list',
                params: { headerId: item.headerId, headerUrl: item.headerUrl },
              }"
            >
              {{ item.name }}
            </router-link>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script src="./nav-browse-categories-overlay.js"></script>
<style src="./nav-browse-categories-overlay.scss" lang="scss"></style>
